import * as React from "react";
const SvgFiRrSprayCanSparkles = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-spray-can-sparkles_svg__a)">
      <path
        fill="#062147"
        d="m18.46 3.215-.968.277-.277.968c-.206.72-1.225.72-1.431 0l-.277-.968-.968-.277c-.72-.206-.72-1.225 0-1.431l.968-.277.277-.968c.206-.719 1.225-.719 1.431 0l.277.968.968.277c.72.206.72 1.225 0 1.431m5 1.569-.968-.277-.277-.968c-.206-.719-1.225-.719-1.431 0l-.277.968-.968.277c-.72.206-.72 1.225 0 1.431l.968.277.277.968c.206.72 1.225.72 1.431 0l.277-.968.968-.277c.72-.206.72-1.225 0-1.431m-1 6-.968-.277-.277-.968c-.206-.719-1.225-.719-1.431 0l-.277.968-.968.277c-.72.206-.72 1.225 0 1.431l.968.277.277.968c.206.72 1.225.72 1.431 0l.277-.968.968-.277c.72-.206.72-1.225 0-1.431M16 11.999v7c0 2.757-2.243 5-5 5H5c-2.757 0-5-2.243-5-5v-7A5.01 5.01 0 0 1 4 7.1V3.499c0-1.93 1.57-3.5 3.5-3.5h1c1.93 0 3.5 1.57 3.5 3.5V7.1c2.279.465 4 2.484 4 4.899M6 7h4V3.5C10 2.673 9.327 2 8.5 2h-1C6.673 2 6 2.673 6 3.5zm8 5c0-1.654-1.346-3-3-3H5c-1.654 0-3 1.346-3 3v7c0 1.654 1.346 3 3 3h6c1.654 0 3-1.346 3-3zm-2 4c0 2.206-1.794 4-4 4s-4-1.794-4-4 1.794-4 4-4 4 1.794 4 4m-2 0c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2 2-.897 2-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-spray-can-sparkles_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSprayCanSparkles;
